import { createFileRoute, redirect } from '@tanstack/react-router';
import { NewsArticleDetail } from '~/components/sections/NewsArticleDetail';
import type { LearnArticle } from '~/content/learn';
import { getNewsArticle, NEWS_URL_PREFIX, type NewsArticle } from '~/content/news';
import { learnArticleHeadMeta } from '~/lib/learn-article-route';

/** Adapt a release to the Learn head builder so canonical, OG and Article JSON-LD match. */
function toHeadArticle(article: NewsArticle): LearnArticle {
  return {
    title: article.title,
    date: article.publishedAt,
    category: 'News',
    excerpt: article.excerpt,
    slug: article.slug,
    urlPrefix: NEWS_URL_PREFIX,
    fullPath: `${NEWS_URL_PREFIX}/${article.slug}`,
    body: article.body,
    author: { name: 'nsave', avatar: '' },
  };
}

export const Route = createFileRoute('/news_/$slug')({
  loader: ({ params }) => {
    const article = getNewsArticle(params.slug);
    if (!article) throw redirect({ to: '/news' });
    return { article };
  },
  head: ({ loaderData }) =>
    learnArticleHeadMeta(loaderData ? toHeadArticle(loaderData.article) : undefined),
  component: NewsArticlePage,
});

function NewsArticlePage() {
  const { article } = Route.useLoaderData();
  return <NewsArticleDetail key={article.slug} article={article} />;
}
